var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.746 34.7748C13.746 24.3748 18.746 18.7748 21.246 17.2748L21.246 1.77477C4.04599 10.5748 0.412659 27.4415 0.745993 34.7748C1.94599 61.9748 22.6852 68.7748 33.746 68.7748C61.2257 68.7748 68.4127 45.1081 68.246 34.7748C69.046 12.7748 53.246 2.94144 45.246 0.774772V15.2748C53.646 21.6748 55.4127 30.9415 55.246 34.7748C52.2257 51.7748 39.5793 52.7748 33.746 52.7748C19.346 53.1748 13.746 41.7748 13.746 34.7748Z",
    fill: "url(#paint0_linear_836_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_836_10",
    x1: 34.7257,
    y1: 34.7748,
    x2: 34.7257,
    y2: 35.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSvg2);
export default __webpack_public_path__ + "static/media/LoadingSVG2.33671292a019f46766cc420ef713c0d9.svg";
export { ForwardRef as ReactComponent };